import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const SocialProofMetrics = () => {
  const [metrics, setMetrics] = useState({
    activePlayers: 8547,
    todayWinnings: 23000000,
    winnersThisHour: 156,
    totalWinnings: 1200000000,
    happyPlayers: 10000,
    avgRating: 4.9
  });

  const [recentWinners, setRecentWinners] = useState([
    { id: 1, name: "Rahul K.", amount: 45000, game: "Teen Patti", time: "2 min ago" },
    { id: 2, name: "Priya S.", amount: 78000, game: "Andar Bahar", time: "5 min ago" },
    { id: 3, name: "Amit P.", amount: 125000, game: "Roulette", time: "8 min ago" },
    { id: 4, name: "Sneha R.", amount: 32000, game: "Dragon Tiger", time: "12 min ago" },
    { id: 5, name: "Vikash M.", amount: 89000, game: "Blackjack", time: "15 min ago" }
  ]);

  const [currentWinnerIndex, setCurrentWinnerIndex] = useState(0);

  useEffect(() => {
    // Update metrics every 5 seconds
    const metricsInterval = setInterval(() => {
      setMetrics(prev => ({
        ...prev,
        activePlayers: prev?.activePlayers + Math.floor(Math.random() * 20) - 10,
        todayWinnings: prev?.todayWinnings + Math.floor(Math.random() * 50000),
        winnersThisHour: prev?.winnersThisHour + Math.floor(Math.random() * 3)
      }));
    }, 5000);

    // Rotate recent winners every 3 seconds
    const winnersInterval = setInterval(() => {
      setCurrentWinnerIndex(prev => (prev + 1) % recentWinners?.length);
    }, 3000);

    return () => {
      clearInterval(metricsInterval);
      clearInterval(winnersInterval);
    };
  }, [recentWinners?.length]);

  const formatCurrency = (amount) => {
    if (amount >= 10000000) {
      return `₹${(amount / 10000000)?.toFixed(1)}Cr`;
    } else if (amount >= 100000) {
      return `₹${(amount / 100000)?.toFixed(1)}L`;
    } else if (amount >= 1000) {
      return `₹${(amount / 1000)?.toFixed(1)}K`;
    }
    return `₹${amount?.toLocaleString()}`;
  };

  const liveMetrics = [
    {
      id: 1,
      icon: 'Users',
      label: 'Players Online',
      value: metrics?.activePlayers?.toLocaleString(),
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/20',
      trend: '+12%'
    },
    {
      id: 2,
      icon: 'TrendingUp',
      label: 'Today\'s Winnings',
      value: formatCurrency(metrics?.todayWinnings),
      color: 'text-green-500',
      bgColor: 'bg-green-500/20',
      trend: '+8%'
    },
    {
      id: 3,
      icon: 'Trophy',
      label: 'Winners This Hour',
      value: metrics?.winnersThisHour?.toString(),
      color: 'text-yellow-500',
      bgColor: 'bg-yellow-500/20',
      trend: '+15%'
    },
    {
      id: 4,
      icon: 'Star',
      label: 'Player Rating',
      value: `${metrics?.avgRating}★`,
      color: 'text-purple-500',
      bgColor: 'bg-purple-500/20',
      trend: 'Excellent'
    }
  ];

  return (
    <section className="py-12 bg-gradient-to-r from-gray-900 via-black to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Live Metrics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          {liveMetrics?.map((metric) => (
            <div key={metric?.id} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/15 transition-colors duration-300">
              <div className={`w-12 h-12 ${metric?.bgColor} rounded-full flex items-center justify-center mx-auto mb-3`}>
                <Icon name={metric?.icon} size={24} color={metric?.color?.replace('text-', '')} />
              </div>
              <div className="text-2xl font-bold text-white mb-1">{metric?.value}</div>
              <div className="text-sm text-gray-300 mb-1">{metric?.label}</div>
              <div className="text-xs text-green-400">{metric?.trend}</div>
            </div>
          ))}
        </div>

        {/* Recent Winners Ticker */}
        <div className="bg-gradient-royal rounded-xl p-6 mb-8">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
              <span className="text-white font-semibold">LIVE WINNERS</span>
            </div>
            <div className="text-white/80 text-sm">Updated every minute</div>
          </div>
          
          <div className="relative h-16 overflow-hidden">
            <div 
              className="absolute inset-0 transition-transform duration-500 ease-in-out"
              style={{ transform: `translateY(-${currentWinnerIndex * 64}px)` }}
            >
              {recentWinners?.map((winner, index) => (
                <div key={winner?.id} className="h-16 flex items-center justify-between text-white">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                      <Icon name="User" size={20} color="white" />
                    </div>
                    <div>
                      <div className="font-semibold">{winner?.name}</div>
                      <div className="text-sm text-white/80">{winner?.game}</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-xl font-bold text-green-300">
                      +{formatCurrency(winner?.amount)}
                    </div>
                    <div className="text-xs text-white/60">{winner?.time}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Shield" size={32} color="#22C55E" />
            </div>
            <div className="text-2xl font-bold text-white mb-2">100% Secure</div>
            <div className="text-gray-300 text-sm">Bank-grade encryption & SSL security</div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
            <div className="w-16 h-16 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Zap" size={32} color="#3B82F6" />
            </div>
            <div className="text-2xl font-bold text-white mb-2">5 Min Payouts</div>
            <div className="text-gray-300 text-sm">Fastest withdrawal in India</div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
            <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="MessageCircle" size={32} color="#EAB308" />
            </div>
            <div className="text-2xl font-bold text-white mb-2">24/7 Support</div>
            <div className="text-gray-300 text-sm">Personal WhatsApp assistance</div>
          </div>
        </div>

        {/* Overall Stats */}
        <div className="mt-8 text-center">
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div>
                <div className="text-3xl font-bold text-gradient-royal mb-1">
                  {formatCurrency(metrics?.totalWinnings)}
                </div>
                <div className="text-gray-400 text-sm">Total Winnings Paid</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-gradient-royal mb-1">
                  {metrics?.happyPlayers?.toLocaleString()}+
                </div>
                <div className="text-gray-400 text-sm">Happy Players</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-gradient-royal mb-1">3 Years</div>
                <div className="text-gray-400 text-sm">Trusted Service</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-gradient-royal mb-1">50+</div>
                <div className="text-gray-400 text-sm">Premium Games</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofMetrics;